import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as RNLocalize from 'react-native-localize';

import en from './locales/en.json';

const LANG_STORAGE_KEY = '@tailorapp_language';

const languageDetector = {
  type: 'languageDetector',
  async: true,
  detect: async callback => {
    const storedLang = await AsyncStorage.getItem(LANG_STORAGE_KEY);
    if (storedLang) {
      callback(storedLang);
      return;
    }
    const locales = RNLocalize.getLocales();
    const bestMatch = locales[0]?.languageCode || 'en';
    callback(bestMatch);
  },
  init: () => {},
  cacheUserLanguage: async lang => {
    await AsyncStorage.setItem(LANG_STORAGE_KEY, lang);
  },
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {translation: en},
    },
    fallbackLng: 'en',
    interpolation: {escapeValue: false},
    react: {useSuspense: false},
  });

export default i18n;
